export default { // 自行分类
  login:{
    login:'登录'
  },
  head:{
    title: '成都奕成科技股份有限公司-官网-奕成科技 ECHINT'
  },
  home:{
    technologies:'产品技术',
    overview:'技术总览',
    platform:'技术平台',
    advantages:'技术优势',
    services:'卓越服务',
    panelLevelPackaging:'封测服务',
    designSimulation:'设计仿真服务',
    labServices:'实验室服务',
    supportServices:'服务保障',
    contactUs:'联系我们',
    aboutECHINT:'关于奕成',
    companyProfile:'公司简介',
    qualityAssurance:'质量保障',
    compliance:'合规管理',
    newsroom:'新闻中心',
    joinUs:'加入我们',
    search:'搜索',
    keywords:'关键词',
    year:'年'
  },
  footer:{
    ECHINT: '奕成科技',
    Wechat:'微信公众号'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zn.js